import * as ng from 'angular';
import { ComponentRegistration } from '../../../core';
import { Dto } from '../../../data';
import { IAccountRequestService } from './../';
let template = require('./pending-approval-details.html');

class PendingApprovalDetailsComponent extends ComponentRegistration {

    constructor() {
        super('pendingApprovalDetails', {
            controller: PendingApprovalDetailsController,
            templateUrl: template,
            controllerAs: 'vm',
            bindings: {
                originalAccountRequest: '<?accountRequest',
                onSave: '&?',
                onLoadUserCancel: '&?'
            }
        });
    }
}

interface IPendingApprovalDetailsController {

}

class PendingApprovalDetailsController implements IPendingApprovalDetailsController {
    private static $inject: Array<string> = ['$scope', '$rootRouter', 'AccountRequestService', '$mdDialog'];
    private accountRequest: Dto.IAccountRequest;
    private denyMessage = "Deny with changes?";
    private pendingApprovalForm: ng.IFormController;
    private isReservedParkingRequest: boolean;

    //Bindings
    private _originalAccountRequest: Dto.IAccountRequest;
    private inEditMode: boolean;
    private onSave: Function;
    private onLoadUserCancel: Function;

    constructor(private $scope: ng.IScope,
        private $rootRouter: ng.Router,
        private AccountRequestService: IAccountRequestService,
        private $mdDialog: ng.material.IDialogService) {
        console.log('PendingApprovalDetailsController loading');
        this.activate();
    }

    public $onInit(): void {
       
    }

    public get originalAccountRequest() {
        return this._originalAccountRequest;
    }

    public set originalAccountRequest(val: Dto.IAccountRequest) {
        if (this._originalAccountRequest !== val) {
            this._originalAccountRequest = val;
            this.accountRequest = ng.copy(this._originalAccountRequest);
            if (this.accountRequest) {
                this.AccountRequestService.get(this.accountRequest.id, this.accountRequest.accountId)
                    .then((accountRequest) => {
                        this.accountRequest = accountRequest;
                        this.isReservedParkingRequest = accountRequest.isReserveParkingRequest;
                        this.inEditMode = (this.accountRequest.id !== undefined);
                    });
            }
        }
    }

    public activate(): void {
        console.log('PendingApprovalDetailsController loaded');
    }

    public onDeny(args): void {
        if (!this.accountRequest) return;

        let completeDeny = (args) => {
            if (args.send) {
                if (this.accountRequest.id) {
                    this.accountRequest.accountDeniedMessage = args.message;
                    this.accountRequest.accountStatus = Dto.AccountStatus.AccountDenied;
                    this.AccountRequestService.update(this.accountRequest).then((accountRequest) => {
                        this.accountRequest = null;
                        this.originalAccountRequest = null;
                        this.inEditMode = false;
                        this.raiseOnSave(accountRequest);
                    });
                }
            }
        }

        this.$mdDialog.show({
            parent: ng.element(document.body),
            template: '<md-dialog aria-label="MyLabel"><deny-message-dialog></<deny-message-dialog></md-dialog>'
        }).then(
            (args) => { completeDeny(args); }
        );       
    }

    public onApprove(args): void {
        if (!this.accountRequest) return;

        if (this.accountRequest.id) {
            this.accountRequest.accountStatus = Dto.AccountStatus.Active;
            this.AccountRequestService.update(this.accountRequest).then((accountRequest) => {
                this.accountRequest = null;
                this.originalAccountRequest = null
                this.inEditMode = false;
                this.raiseOnSave(accountRequest);
            });
        }
    }

    public raiseOnSave(accountRequest: Dto.IAccountRequest): void {
        if (typeof this.onSave === 'function') {
            this.onSave({
                accountRequest: accountRequest
            });
        }
    }
}

let pendingApprovalDetailsComponent = new PendingApprovalDetailsComponent();
export default pendingApprovalDetailsComponent;
export { pendingApprovalDetailsComponent as PendingApprovalDetailsComponent, IPendingApprovalDetailsController, PendingApprovalDetailsController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/admin/pending-approval/pending-approval-details.ts